
import React, { Component, useEffect, useState, useMemo } from "react";
import './ZoneItem.scss'
import cjzPng from '../../../../../images/照片采集中.png'
import homePng from '../../../../../images/home/home.png'
import locationPng from '../../../../../images/home/location.png'
import { RoutePath } from "../../../../../constants/RoutePath";

const ZoneItem = (props) => {
  let { dispatch, router, item } = props
  let {
    zoneId,
    number,
    rentShow,
    rentShowMonth = '',
    rentShowYear = '',
    name,
    district,
    town,
    vacantAreaStr,
    tags = [],
    brokerPhoto,
    brokerName,
    zoneMainPhoto,
  } = item

  let addr = [district, town].filter((item) => !!item)


  let photoUrl = zoneMainPhoto
    ? zoneMainPhoto + '?x-oss-process=style/WaterResize'
    : cjzPng

  const goDetail = () => {
    router.navigate(RoutePath.WMS_ZONE_DETAIL.path.replace(":id", zoneId));
  }

  return (
    <div className="ZoneItem" onClick={() => { goDetail() }}>
      <div className="zoneItemImg">
        <img src={photoUrl} />
        <div>

          {
            rentShow === '面议' ?
              <p>面议</p>
              :
              <p style={{ fontSize: '10px' }}>
                <p>{rentShow} 元/㎡/天</p>
                <p>预计有效租金-不含税含物业</p>
              </p>
          }
        </div>
      </div>
      <p className="zoneTitle">{name}</p>
      <div className="zoneSubTitle">
        <img src={locationPng} />
        <p>{addr.join('-')}</p>
      </div>
      <div className="zoneSubTitle">
        <img src={homePng} />
        <p>{vacantAreaStr} ㎡</p>
      </div>

      <div className="zoneUser">
        <img src={brokerPhoto} />
        <p>{brokerName}</p>
      </div>
    </div>
  );
};



export default ZoneItem
